// Enquiry retention helper.
// Pending enquiries → 30 days from created_at.
// Responded ("quoted"/"responded") / closed enquiries → 180 days from
// last_response_at (fallback to created_at for legacy docs).
// Returns null when the anchor timestamp cannot be parsed.

const PENDING_LIMIT_DAYS = 30;
const RESPONDED_LIMIT_DAYS = 180;

export function computeRetention({ status, created_at, last_response_at } = {}) {
  const s = (status || "").toLowerCase();
  const isPending = s === "pending";
  const limitDays = isPending ? PENDING_LIMIT_DAYS : RESPONDED_LIMIT_DAYS;
  const anchor = isPending ? created_at : (last_response_at || created_at);
  if (!anchor) return null;
  const anchorDate = new Date(anchor);
  if (Number.isNaN(anchorDate.getTime())) return null;
  const elapsedMs = Date.now() - anchorDate.getTime();
  const elapsedDays = Math.floor(elapsedMs / (1000 * 60 * 60 * 24));
  const daysLeft = Math.max(0, limitDays - elapsedDays);
  return { daysLeft, limitDays, isPending };
}
